// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CostStatement  {
    _originalTypeClassName = "Loom.BO.CostStatement";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CostStatement.translate = translateService;
}
this.SubcontractingCostsDetails = [];
this.ODC_TravelDetails = [];
this.ODC_EquipmentDetails = [];
this.ODC_OtherGoods = [];
this.ApprovalsHistory = [];
this.PersonnelCostsDetails = [];
this.CostStatementEffortDetails = [];
this.Id = null;
this.DateSubmittedToEC = null;
this.DateCreated = null;
this.GATotalPMs = null;
this.LinearProjectionPMsInclPeriod = null;
this.ReportedPMsUntilPeriodStart = null;
this.TotalPeriodPMs = null;
this.TotalReportedPMsInclPeriod = null;
this.TotalPMPercentage = null;
this.TotalPMDeviationFromGA = null;
this.GAPersonnelCosts = null;
this.LinearExpectedPersonnel = null;
this.PersonnelCosts_A1A2A3_actuals = null;
this.PersonnelCosts_A1A2A3_unit = null;
this.PersonnelCosts_A4_unit = null;
this.PersonnelCosts = null;
this.TotalPersonnelCostsInclPeriod = null;
this.TotalPersonnelCostsPercentage = null;
this.SubcontractingCosts = null;
this.OtherDirectCosts_TravelCosts = null;
this.OtherDirectCosts_Equipment = null;
this.OtherDirectCosts_OtherGoods = null;
this.OtherDirectCosts = null;
this.OtherCostCategories = null;
this.IndirectCosts = null;
this.MaxEUContribution = null;
this.PreviouslyReportedEligibleCosts = null;
this.TotalEstimatedEligibleCosts = null;
this.TotalEligibleCostsInclPeriod = null;
this.FundingRate = null;
this.RequestedEUContribution = null;
this.GATotalCosts = null;
this.TotalRequestedContribution = null;
this.TotalCostsPercentage = null;
this.GAPMRate = null;
this.PeriodCalculatedPMRate = null;
this.TotalPMRateDeviationFromGA = null;
this.PMRateDeviationJustification = null;
this.EUProject = false;
this.NeedsCFS = false;
this.IsDraft = true;
this.StartDate = null;
this.EndDate = null;
this.IsFormal = false;
this.Status = null;
this.LastModified = null;
this.LinearProjectionFactor = null;
this.PreviouslyReportedPersonnelCosts = null;
this.PreviouslyReportedSubcontractingCosts = null;
this.PreviouslyReportedTravelCosts = null;
this.PreviouslyReportedEquipment = null;
this.PreviouslyReportedOtherGoods = null;
this.PreviouslyReportedIndirectCosts = null;
this.TotalTravelCostsInclPeriod = null;
this.TotalEquipmentInclPeriod = null;
this.TotalOtherGoodsInclPeriod = null;
this.TotalSubcontractingInclPeriod = null;
this.TotalOtherDirectCostsInclPeriod = null;
this.TotalIndirectCostsInclPeriod = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateSubmittedToEC:any;
DateCreated:any;
GATotalPMs:any;
LinearProjectionPMsInclPeriod:any;
ReportedPMsUntilPeriodStart:any;
TotalPeriodPMs:any;
TotalReportedPMsInclPeriod:any;
TotalPMPercentage:any;
TotalPMDeviationFromGA:any;
GAPersonnelCosts:any;
LinearExpectedPersonnel:any;
PersonnelCosts_A1A2A3_actuals:any;
PersonnelCosts_A1A2A3_unit:any;
PersonnelCosts_A4_unit:any;
PersonnelCosts:any;
TotalPersonnelCostsInclPeriod:any;
TotalPersonnelCostsPercentage:any;
SubcontractingCosts:any;
OtherDirectCosts_TravelCosts:any;
OtherDirectCosts_Equipment:any;
OtherDirectCosts_OtherGoods:any;
OtherDirectCosts:any;
OtherCostCategories:any;
IndirectCosts:any;
MaxEUContribution:any;
PreviouslyReportedEligibleCosts:any;
TotalEstimatedEligibleCosts:any;
TotalEligibleCostsInclPeriod:any;
FundingRate:any;
RequestedEUContribution:any;
GATotalCosts:any;
TotalRequestedContribution:any;
TotalCostsPercentage:any;
GAPMRate:any;
PeriodCalculatedPMRate:any;
TotalPMRateDeviationFromGA:any;
PMRateDeviationJustification:any;
EUProject:any;
NeedsCFS:any;
IsDraft:any;
StartDate:any;
EndDate:any;
IsFormal:any;
Status:any;
LastModified:any;
LinearProjectionFactor:any;
PreviouslyReportedPersonnelCosts:any;
PreviouslyReportedSubcontractingCosts:any;
PreviouslyReportedTravelCosts:any;
PreviouslyReportedEquipment:any;
PreviouslyReportedOtherGoods:any;
PreviouslyReportedIndirectCosts:any;
TotalTravelCostsInclPeriod:any;
TotalEquipmentInclPeriod:any;
TotalOtherGoodsInclPeriod:any;
TotalSubcontractingInclPeriod:any;
TotalOtherDirectCostsInclPeriod:any;
TotalIndirectCostsInclPeriod:any;
ProjectParticipant:any;
ReportingPeriod:any;
Project:any;
SubcontractingCostsDetails:any;
ODC_TravelDetails:any;
ODC_EquipmentDetails:any;
ODC_OtherGoods:any;
ApprovalsHistory:any;
LastModifiedBy:any;
CreatedBy:any;
PersonnelCostsDetails:any;
CostStatementEffortDetails:any;
static setProjectParticipant = ($this, value) => {
var oldValue = $this.ProjectParticipant;
$this.ProjectParticipant = value;
if (value != null) {
}
}
static setReportingPeriod = ($this, value) => {
var oldValue = $this.ReportingPeriod;
$this.ReportingPeriod = value;
if (value != null) {
}
}
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setSubcontractingCostsDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubcontractingCostsDetails == null) $this.SubcontractingCostsDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubcontractingCostsDetails.length > 0) {
                    Domain.CostStatement.removeSubcontractingCostsDetails($this, $this.SubcontractingCostsDetails[0]);
                }

                Domain.CostStatement.addManySubcontractingCostsDetails($this, copyItems);
            }
static addManySubcontractingCostsDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addSubcontractingCostsDetails($this, items[i]);
                }
            }
static addSubcontractingCostsDetails = ($this, item) => {
                if ($this.SubcontractingCostsDetails == null) $this.SubcontractingCostsDetails = [];
                if (item == null || $this.SubcontractingCostsDetails.indexOf(item) > -1) return;
                $this.SubcontractingCostsDetails.push(item);
if (item.SubcontractingCostStatement != $this) {
Domain.SubcontractingCostDetail.setSubcontractingCostStatement(item, $this);
}
}
static addRangeSubcontractingCostsDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addSubcontractingCostsDetails($this, item));
            }
static removeSubcontractingCostsDetails = ($this, item) => {
                if ($this == null || $this.SubcontractingCostsDetails == null || $this.SubcontractingCostsDetails.indexOf(item) === -1) return;
                var _index = $this.SubcontractingCostsDetails.indexOf(item);
                $this.SubcontractingCostsDetails.splice(_index, 1);
item.SubcontractingCostStatement = null;
}
static clearSubcontractingCostsDetails = ($this) => { $this.SubcontractingCostsDetails = null; }
static setODC_TravelDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.ODC_TravelDetails == null) $this.ODC_TravelDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ODC_TravelDetails.length > 0) {
                    Domain.CostStatement.removeODC_TravelDetails($this, $this.ODC_TravelDetails[0]);
                }

                Domain.CostStatement.addManyODC_TravelDetails($this, copyItems);
            }
static addManyODC_TravelDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addODC_TravelDetails($this, items[i]);
                }
            }
static addODC_TravelDetails = ($this, item) => {
                if ($this.ODC_TravelDetails == null) $this.ODC_TravelDetails = [];
                if (item == null || $this.ODC_TravelDetails.indexOf(item) > -1) return;
                $this.ODC_TravelDetails.push(item);
if (item.CostStatement != $this) {
Domain.ODC_Travel.setCostStatement(item, $this);
}
}
static addRangeODC_TravelDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addODC_TravelDetails($this, item));
            }
static removeODC_TravelDetails = ($this, item) => {
                if ($this == null || $this.ODC_TravelDetails == null || $this.ODC_TravelDetails.indexOf(item) === -1) return;
                var _index = $this.ODC_TravelDetails.indexOf(item);
                $this.ODC_TravelDetails.splice(_index, 1);
item.CostStatement = null;
}
static clearODC_TravelDetails = ($this) => { $this.ODC_TravelDetails = null; }
static setODC_EquipmentDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.ODC_EquipmentDetails == null) $this.ODC_EquipmentDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ODC_EquipmentDetails.length > 0) {
                    Domain.CostStatement.removeODC_EquipmentDetails($this, $this.ODC_EquipmentDetails[0]);
                }

                Domain.CostStatement.addManyODC_EquipmentDetails($this, copyItems);
            }
static addManyODC_EquipmentDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addODC_EquipmentDetails($this, items[i]);
                }
            }
static addODC_EquipmentDetails = ($this, item) => {
                if ($this.ODC_EquipmentDetails == null) $this.ODC_EquipmentDetails = [];
                if (item == null || $this.ODC_EquipmentDetails.indexOf(item) > -1) return;
                $this.ODC_EquipmentDetails.push(item);
if (item.CostStatement != $this) {
Domain.ODC_Equipment.setCostStatement(item, $this);
}
}
static addRangeODC_EquipmentDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addODC_EquipmentDetails($this, item));
            }
static removeODC_EquipmentDetails = ($this, item) => {
                if ($this == null || $this.ODC_EquipmentDetails == null || $this.ODC_EquipmentDetails.indexOf(item) === -1) return;
                var _index = $this.ODC_EquipmentDetails.indexOf(item);
                $this.ODC_EquipmentDetails.splice(_index, 1);
item.CostStatement = null;
}
static clearODC_EquipmentDetails = ($this) => { $this.ODC_EquipmentDetails = null; }
static setODC_OtherGoods = ($this, items) => {
                if (items == null) items = [];
                if ($this.ODC_OtherGoods == null) $this.ODC_OtherGoods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ODC_OtherGoods.length > 0) {
                    Domain.CostStatement.removeODC_OtherGoods($this, $this.ODC_OtherGoods[0]);
                }

                Domain.CostStatement.addManyODC_OtherGoods($this, copyItems);
            }
static addManyODC_OtherGoods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addODC_OtherGoods($this, items[i]);
                }
            }
static addODC_OtherGoods = ($this, item) => {
                if ($this.ODC_OtherGoods == null) $this.ODC_OtherGoods = [];
                if (item == null || $this.ODC_OtherGoods.indexOf(item) > -1) return;
                $this.ODC_OtherGoods.push(item);
if (item.CostStatement != $this) {
Domain.ODC_OtherGoods.setCostStatement(item, $this);
}
}
static addRangeODC_OtherGoods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addODC_OtherGoods($this, item));
            }
static removeODC_OtherGoods = ($this, item) => {
                if ($this == null || $this.ODC_OtherGoods == null || $this.ODC_OtherGoods.indexOf(item) === -1) return;
                var _index = $this.ODC_OtherGoods.indexOf(item);
                $this.ODC_OtherGoods.splice(_index, 1);
item.CostStatement = null;
}
static clearODC_OtherGoods = ($this) => { $this.ODC_OtherGoods = null; }
static setApprovalsHistory = ($this, items) => {
                if (items == null) items = [];
                if ($this.ApprovalsHistory == null) $this.ApprovalsHistory = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ApprovalsHistory.length > 0) {
                    Domain.CostStatement.removeApprovalsHistory($this, $this.ApprovalsHistory[0]);
                }

                Domain.CostStatement.addManyApprovalsHistory($this, copyItems);
            }
static addManyApprovalsHistory = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addApprovalsHistory($this, items[i]);
                }
            }
static addApprovalsHistory = ($this, item) => {
                if ($this.ApprovalsHistory == null) $this.ApprovalsHistory = [];
                if (item == null || $this.ApprovalsHistory.indexOf(item) > -1) return;
                $this.ApprovalsHistory.push(item);
if (item.CostStatement != $this) {
Domain.ApprovalHistory.setCostStatement(item, $this);
}
}
static addRangeApprovalsHistory = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addApprovalsHistory($this, item));
            }
static removeApprovalsHistory = ($this, item) => {
                if ($this == null || $this.ApprovalsHistory == null || $this.ApprovalsHistory.indexOf(item) === -1) return;
                var _index = $this.ApprovalsHistory.indexOf(item);
                $this.ApprovalsHistory.splice(_index, 1);
item.CostStatement = null;
}
static clearApprovalsHistory = ($this) => { $this.ApprovalsHistory = null; }
static setLastModifiedBy = ($this, value) => {
var oldValue = $this.LastModifiedBy;
$this.LastModifiedBy = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setPersonnelCostsDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.PersonnelCostsDetails == null) $this.PersonnelCostsDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PersonnelCostsDetails.length > 0) {
                    Domain.CostStatement.removePersonnelCostsDetails($this, $this.PersonnelCostsDetails[0]);
                }

                Domain.CostStatement.addManyPersonnelCostsDetails($this, copyItems);
            }
static addManyPersonnelCostsDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addPersonnelCostsDetails($this, items[i]);
                }
            }
static addPersonnelCostsDetails = ($this, item) => {
                if ($this.PersonnelCostsDetails == null) $this.PersonnelCostsDetails = [];
                if (item == null || $this.PersonnelCostsDetails.indexOf(item) > -1) return;
                $this.PersonnelCostsDetails.push(item);
if (item.CostStatement != $this) {
Domain.PersonnelCostsPerCategoryDetail.setCostStatement(item, $this);
}
}
static addRangePersonnelCostsDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addPersonnelCostsDetails($this, item));
            }
static removePersonnelCostsDetails = ($this, item) => {
                if ($this == null || $this.PersonnelCostsDetails == null || $this.PersonnelCostsDetails.indexOf(item) === -1) return;
                var _index = $this.PersonnelCostsDetails.indexOf(item);
                $this.PersonnelCostsDetails.splice(_index, 1);
item.CostStatement = null;
}
static clearPersonnelCostsDetails = ($this) => { $this.PersonnelCostsDetails = null; }
static setCostStatementEffortDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.CostStatementEffortDetails == null) $this.CostStatementEffortDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CostStatementEffortDetails.length > 0) {
                    Domain.CostStatement.removeCostStatementEffortDetails($this, $this.CostStatementEffortDetails[0]);
                }

                Domain.CostStatement.addManyCostStatementEffortDetails($this, copyItems);
            }
static addManyCostStatementEffortDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CostStatement.addCostStatementEffortDetails($this, items[i]);
                }
            }
static addCostStatementEffortDetails = ($this, item) => {
                if ($this.CostStatementEffortDetails == null) $this.CostStatementEffortDetails = [];
                if (item == null || $this.CostStatementEffortDetails.indexOf(item) > -1) return;
                $this.CostStatementEffortDetails.push(item);
if (item.CostStatement != $this) {
Domain.CostStatementEffortDetail.setCostStatement(item, $this);
}
}
static addRangeCostStatementEffortDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CostStatement.addCostStatementEffortDetails($this, item));
            }
static removeCostStatementEffortDetails = ($this, item) => {
                if ($this == null || $this.CostStatementEffortDetails == null || $this.CostStatementEffortDetails.indexOf(item) === -1) return;
                var _index = $this.CostStatementEffortDetails.indexOf(item);
                $this.CostStatementEffortDetails.splice(_index, 1);
item.CostStatement = null;
}
static clearCostStatementEffortDetails = ($this) => { $this.CostStatementEffortDetails = null; }

static CreateEffortDetails(cs: any,workPackageAssignments: any,previousCSs: any,startMonthRP: any,endMonthRP: any): any{let participantEntryMonth = (CLMS.Framework.Number.GreaterThan(() => cs.ProjectParticipant.EntryMonth, () => 0) ? cs?.ProjectParticipant?.EntryMonth : 1);
let participantExitMonth = (CLMS.Framework.Number.GreaterThan(() => cs.ProjectParticipant.ExitMonth, () => 0) ? cs?.ProjectParticipant?.ExitMonth : cs?.Project?.Duration);
let lastPreviousCS = previousCSs?.linq?.lastOrDefault();
for (let _iwpa = 0; _iwpa < (workPackageAssignments == null ? 0 : workPackageAssignments.length); _iwpa++) {let wpa = workPackageAssignments[_iwpa];let pcd = new Domain.CostStatementEffortDetail();Domain.CostStatementEffortDetail.setCostStatement(pcd, cs);Domain.CostStatementEffortDetail.setWorkPackage(pcd, wpa?.WorkPackage);pcd.GATotalPMs = wpa?.Effort;let wpStartMonth = (CLMS.Framework.Number.GreaterThan(() => pcd.WorkPackage.StartMonth, () => 0) ? pcd?.WorkPackage?.StartMonth : 1);let wpEndMonth = (CLMS.Framework.Number.GreaterThan(() => pcd.WorkPackage.EndMonth, () => 0) ? pcd?.WorkPackage?.EndMonth : cs?.Project?.Duration);let wpDuration = (Joove.Common.safeNumber(wpEndMonth) - Joove.Common.safeNumber(wpStartMonth) + Joove.Common.safeNumber(1));let start = Math.max(wpStartMonth, participantEntryMonth);let end = Math.min(Math.min(endMonthRP, wpEndMonth), participantExitMonth);let linearConsumptionFactorForWP = Joove.Common.safeNumber((parseFloat(((Joove.Common.safeNumber(end) - Joove.Common.safeNumber(start) + Joove.Common.safeNumber(1))) as any))) / Joove.Common.safeNumber((parseFloat((wpDuration) as any)));if (CLMS.Framework.Number.LessThan(() => linearConsumptionFactorForWP, () => 0)) {linearConsumptionFactorForWP = 0;}pcd.LinearProjectionPMsInclPeriod = Joove.Common.mathRound(Joove.Common.safeNumber(pcd?.GATotalPMs) * Joove.Common.safeNumber(linearConsumptionFactorForWP), 2);if ((lastPreviousCS != null)) {pcd.ReportedPMsUntilPeriodStart = lastPreviousCS?.CostStatementEffortDetails?.linq?.where((a) => a?.WorkPackage == pcd?.WorkPackage)?.toArray()?.linq?.sum((a) => a?.TotalReportedPMsInclPeriod);let prevJustifications = lastPreviousCS?.CostStatementEffortDetails?.linq?.where((a) => a?.WorkPackage == pcd?.WorkPackage)?.toArray()?.linq?.select((a) => a?.DeviationJustification)?.toArray()?.linq?.where((a) => !(CLMS.Framework.String.IsNullOrEmpty((a ?? '').trim())))?.toArray();if ((CLMS.Framework.Number.GreaterThan(() => prevJustifications.length, () => 0))) {pcd.PreviousDeviationJustifications = CLMS.Framework.String.Join("\n ", prevJustifications);}}else {pcd.ReportedPMsUntilPeriodStart = 0;}console.debug(CLMS.Framework.String.Format("Project: {0}, Participant: {1}, RP:{2}, WP: {3}", cs?.Project?.Acronym, cs?.ProjectParticipant?.ShortName, cs?.ReportingPeriod?.Title, pcd?.WorkPackage?.WPNumber));console.debug("---> WP Start month: " + Joove.Common.safeNumber(wpStartMonth));console.debug("---> WP End month: " + Joove.Common.safeNumber(wpEndMonth));console.debug("---> Beneficiary Entry month: " + Joove.Common.safeNumber(participantEntryMonth));console.debug("---> Beneficiary Exit month: " + Joove.Common.safeNumber(participantExitMonth));console.debug("---> Selected Start month: " + Joove.Common.safeNumber(start));console.debug("---> Selected End month: " + Joove.Common.safeNumber(end));console.debug("---> Duration of WP: " + Joove.Common.safeNumber(wpDuration));console.debug("---> LINEAR FACTOR FOR WP: " + Joove.Common.safeNumber(linearConsumptionFactorForWP));}
}
static GenerateCostStatement(project: any,pp: any,rp: any,startDate: any,endDate: any): any{throw Error("Needs refactoring after Cost Statement restructuring!");
}
static GetGATotalPMs($this: any): any{return $this?.ProjectParticipant?.TotalEffort;
}
static GetIndirectCosts($this: any): any{let rate = 0.25;
if (($this?.Project != null && CLMS.Framework.Number.GreaterThan(() => $this.Project.IndirectCostsPercentage, () => 0))) {rate = $this?.Project?.IndirectCostsPercentage;}
let baseAmount = 0;
if (($this?.Project == null)) {baseAmount = Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts($this));}else {switch (($this?.Project?.IndirectCostsBase)) {case Domain.IndirectCostsBaseEnum.ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING:
{
baseAmount = Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts($this));break;}
case Domain.IndirectCostsBaseEnum.ALL_ELIGIBLE_DIRECT_COSTS:
{
baseAmount = Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetSubcontractingCosts($this));break;}
case Domain.IndirectCostsBaseEnum.ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY:
{
throw Error("Not implemented ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY!");}
default:
{
baseAmount = Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts($this));break;}
}}
return Joove.Common.mathRound(Joove.Common.safeNumber(rate) * Joove.Common.safeNumber(baseAmount), 2);
}
static GetMaxEUContribution($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetTotalEligibleCostsInclPeriod($this)) * Joove.Common.safeNumber($this?.FundingRate);
}
static GetOtherDirectCosts($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts_TravelCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts_Equipment($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts_OtherGoods($this));
}
static GetOtherDirectCosts_Equipment($this: any): any{return $this?.ODC_EquipmentDetails?.linq?.sum((a) => a?.DepreciationCostInPeriod);
}
static GetOtherDirectCosts_OtherGoods($this: any): any{return $this?.ODC_OtherGoods?.linq?.sum((a) => a?.Amount);
}
static GetOtherDirectCosts_TravelCosts($this: any): any{return $this?.ODC_TravelDetails?.linq?.sum((a) => a?.Amount);
}
static GetPeriodCalculatedPMRate($this: any): any{let totalPMs = Domain.CostStatement.GetTotalReportedPMsInclPeriod($this);
let rate = (CLMS.Framework.Number.GreaterThan(() => totalPMs, () => 0) ? Joove.Common.safeNumber(Domain.CostStatement.GetTotalPersonnelCostsInclPeriod($this)) / Joove.Common.safeNumber(totalPMs) : 0);
return Joove.Common.mathRound(rate, 2);
}
static GetPersonnelCosts($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts_A1A2A3_actuals($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts_A1A2A3_unit($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts_A4_unit($this));
}
static GetPersonnelCosts_A1A2A3_actuals($this: any): any{return $this?.PersonnelCostsDetails?.linq?.where((a) => a?.ECPersonnelCostsCategory == Domain.ECPersonnelCostsCategories.A1A2A3_ActualCosts)?.toArray()?.linq?.sum((a) => a?.PeriodCosts);
}
static GetPersonnelCosts_A1A2A3_unit($this: any): any{return $this?.PersonnelCostsDetails?.linq?.where((a) => a?.ECPersonnelCostsCategory == Domain.ECPersonnelCostsCategories.A1A2A3_UnitCosts)?.toArray()?.linq?.sum((a) => a?.PeriodCosts);
}
static GetPersonnelCosts_A4_unit($this: any): any{return $this?.PersonnelCostsDetails?.linq?.where((a) => a?.ECPersonnelCostsCategory == Domain.ECPersonnelCostsCategories.A4_UnitCosts)?.toArray()?.linq?.sum((a) => a?.PeriodCosts);
}
static GetPreviouslyReportedPersonnelCosts($this: any): any{return $this?.PersonnelCostsDetails?.linq?.sum((a) => a?.ReportedCostsUntilPeriodStart);
}
static GetReportedPMsUntilPeriodStart($this: any): any{return $this?.CostStatementEffortDetails?.linq?.sum((a) => a?.ReportedPMsUntilPeriodStart);
}
static GetRequestedEUContribution($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetTotalEligibleCostsInclPeriod($this)) * Joove.Common.safeNumber($this?.FundingRate);
}
static GetSubcontractingCosts($this: any): any{return $this?.SubcontractingCostsDetails?.linq?.sum((a) => a?.Cost);
}
static GetTotalCostsPercentage($this: any): any{let perc = (CLMS.Framework.Number.GreaterThan(() => $this.GATotalCosts, () => 0) ? Joove.Common.safeNumber(Domain.CostStatement.GetTotalEligibleCostsInclPeriod($this)) / Joove.Common.safeNumber($this?.GATotalCosts) : 0);
return Joove.Common.mathRound(perc, 3);
}
static GetTotalEligibleCostsInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.PreviouslyReportedEligibleCosts) + Joove.Common.safeNumber(Domain.CostStatement.GetTotalEstimatedEligibleCosts($this));
}
static GetTotalEquipmentInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.PreviouslyReportedEquipment) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts_Equipment($this));
}
static GetTotalEstimatedEligibleCosts($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetPersonnelCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetSubcontractingCosts($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts($this)) + Joove.Common.safeNumber($this?.OtherCostCategories) + Joove.Common.safeNumber(Domain.CostStatement.GetIndirectCosts($this));
}
static GetTotalIndirectCostsInclPeriod($this: any): any{let divider = Joove.Common.safeNumber(2) - Joove.Common.safeNumber($this?.ProjectParticipant?.FundingRate);
if ((CLMS.Framework.Number.LessThanOrEqual(() => divider, () => 0))) {return 0;}
return Joove.Common.safeNumber(Domain.CostStatement.GetTotalEligibleCostsInclPeriod($this)) / Joove.Common.safeNumber(divider);
}
static GetTotalOtherDirectCostsInclPeriod($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetTotalTravelCostsInclPeriod($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetTotalEquipmentInclPeriod($this)) + Joove.Common.safeNumber(Domain.CostStatement.GetTotalOtherGoodsInclPeriod($this));
}
static GetTotalOtherGoodsInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.PreviouslyReportedOtherGoods) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts_OtherGoods($this));
}
static GetTotalPeriodPMs($this: any): any{let total = $this?.CostStatementEffortDetails?.linq?.sum((a) => Joove.Common.safeNumber(a?.PeriodPMsForA123Actuals) + Joove.Common.safeNumber(a?.PeriodPMsForA123UnitCosts) + Joove.Common.safeNumber(a?.PeriodPMsForA4UnitCosts));
return Joove.Common.mathRound(total, 2);
}
static GetTotalPersonnelCostsInclPeriod($this: any): any{return $this?.PersonnelCostsDetails?.linq?.sum((a) => a?.TotalReportedCostsInclPeriod);
}
static GetTotalPersonnelCostsPercentage($this: any): any{let perc = (CLMS.Framework.Number.GreaterThan(() => $this.GAPersonnelCosts, () => 0) ? Joove.Common.safeNumber(Domain.CostStatement.GetTotalPersonnelCostsInclPeriod($this)) / Joove.Common.safeNumber($this?.GAPersonnelCosts) : 0);
return Joove.Common.mathRound(perc, 3);
}
static GetTotalPMDeviationFromGA($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.LinearProjectionPMsInclPeriod, () => 0))) {return (CLMS.Framework.Number.LessThanOrEqual(() => Domain.CostStatement.GetTotalReportedPMsInclPeriod($this), () => 0) ? 0 : 1);}
let deviationPercentage = Math.abs(Joove.Common.safeNumber((Joove.Common.safeNumber(Domain.CostStatement.GetTotalReportedPMsInclPeriod($this)) - Joove.Common.safeNumber($this?.LinearProjectionPMsInclPeriod))) / Joove.Common.safeNumber($this?.LinearProjectionPMsInclPeriod));
return Joove.Common.mathRound(deviationPercentage, 2);
}
static GetTotalPMPercentage($this: any): any{let perc = (CLMS.Framework.Number.GreaterThan(() => Domain.CostStatement.GetGATotalPMs($this), () => 0) ? Joove.Common.safeNumber((Joove.Common.cast(Domain.CostStatement.GetTotalReportedPMsInclPeriod($this), "number"))) / Joove.Common.safeNumber((Joove.Common.cast(Domain.CostStatement.GetGATotalPMs($this), "number"))) : 0);
return Joove.Common.mathRound(perc, 2);
}
static GetTotalPMRateDeviationFromGA($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.GAPMRate, () => 0))) {return (CLMS.Framework.Number.LessThanOrEqual(() => Domain.CostStatement.GetPeriodCalculatedPMRate($this), () => 0) ? 0 : 1);}
let deviationPercentage = Joove.Common.safeNumber(Domain.CostStatement.GetPeriodCalculatedPMRate($this)) / Joove.Common.safeNumber($this?.GAPMRate) - Joove.Common.safeNumber(1);
return Joove.Common.mathRound(deviationPercentage, 2);
}
static GetTotalReportedPMsInclPeriod($this: any): any{return $this?.CostStatementEffortDetails?.linq?.sum((a) => a?.TotalReportedPMsInclPeriod);
}
static GetTotalRequestedContribution($this: any): any{return Joove.Common.safeNumber(Domain.CostStatement.GetTotalEligibleCostsInclPeriod($this)) * Joove.Common.safeNumber($this?.FundingRate);
}
static GetTotalSubcontractingInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.PreviouslyReportedSubcontractingCosts) + Joove.Common.safeNumber(Domain.CostStatement.GetSubcontractingCosts($this));
}
static GetTotalTravelCostsInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.PreviouslyReportedTravelCosts) + Joove.Common.safeNumber(Domain.CostStatement.GetOtherDirectCosts_TravelCosts($this));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}